

    function triggerModal() {
      const urlParams = new URLSearchParams(window.location.search);
    const fileParam = urlParams.get('file');

    if (fileParam) {
        const modalId = 'modal' + fileParam.charAt(0).toUpperCase() + fileParam.slice(1);
    const modalElement = document.getElementById(modalId);

    if (modalElement) {
        $(modalElement).modal('show');
        }
      }
    }

    // Trigger the modal when the page loads
    window.onload = triggerModal;
